import script from "./QuizQuestionResponse.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizQuestionResponse.vue?vue&type=script&setup=true&lang=js"

import "./QuizQuestionResponse.vue?vue&type=style&index=0&id=2f9552b2&lang=scss"

const __exports__ = script;

export default __exports__